import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'hcon-table-body',
  template: '<ng-content select="hcon-table-row"></ng-content>',
  styleUrls: ['./table-body.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TableBodyComponent {}
